import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

let menuFlg = false;
let inquiryFlg = false;

$(document).on('click', '.menu-btn', function () {
  let $this = $(this);
  let $target = $('.nav-wrap');
  $this.find('.menu-trigger').stop().toggleClass('active');

  if (menuFlg == false) {
    gsap.to($target, {
      autoAlpha: 1,
      duration: 0.3
    });
    menuFlg = true;
  } else {

    gsap.to($target, {
      autoAlpha: 0,
      duration: 0.3
    });
    menuFlg = false;
  }
  return false;
});



//検索ボックスを開く
// 検索ボックスを開く関数
const openSearchBox = () => {
  gsap.to('.search-block', {
    duration: 0.3,
    autoAlpha: 1,
    ease: 'power2.out',
    onStart: () => {
      $('.search-block').css('display', 'block');
      // 検索入力欄にフォーカス
      setTimeout(() => {
        $('.search-input').focus();
      }, 100);
    }
  });
};

// 検索ボックスを閉じる関数
const closeSearchBox = () => {
  gsap.to('.search-block', {
    duration: 0.2,
    autoAlpha: 0,
    ease: 'power2.in',
    onComplete: () => {
      $('.search-block').css('display', 'none');
    }
  });
};

// 初期状態を設定
gsap.set('.search-block', {
  autoAlpha: 0,
  display: 'none'
});

// クリックイベントの設定
$('.search').on('click', function (e) {
  e.preventDefault();
  openSearchBox();
});

$('.close-btn').on('click', function (e) {
  e.preventDefault();
  closeSearchBox();
});

// 検索ブロック外をクリックした時に閉じる
$(document).on('click', function (e) {
  if (!$(e.target).closest('.search-box').length) {
    closeSearchBox();
  }
});

// ESCキーで閉じる
$(document).on('keydown', function (e) {
  if (e.key === 'Escape') {
    closeSearchBox();
  }
});
